import React, { Fragment, useEffect } from "react";
import PropTypes from "prop-types";
import {
  useTable,
  useGlobalFilter,
  useAsyncDebounce,
  useSortBy,
  useFilters,
  useExpanded,
  usePagination,
} from "react-table";
import {
  Table,
  Row,
  Col,
  Button,
  Input,
  CardBody,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Pagination,
  PaginationItem,
  PaginationLink,
} from "reactstrap";
import styles from "../../../assets/css/OPDCNews.module.css";
import { useState } from "react";
import AddTex from "./AddTex";

const TableContainer = ({
  columns,
  data,
  isGlobalFilter,
  isJobListGlobalFilter,
  isAddOptions,
  isAddUserList,
  handleOrderClicks,
  handleUserClick,
  handleCustomerClick,
  isAddCustList,
  customPageSize,
  className,
  refresh,
  customPageSizeOptions,
}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: {
        pageIndex: 0,
        pageSize: customPageSize,
        sortBy: [
          {
            desc: true,
          },
        ],
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination
  );

  const [open, setOpen] = useState(false);
  const toggleRightCanvas = () => {
    setOpen(!open);
  };
  const generateSortingIndicator = column => {
    return column.isSorted ? (column.isSortedDesc ? " 🔽" : " 🔼") : "";
  };

  // const onChangeInSelect = event => {
  //   setPageSize(Number(event.target.value));
  // };

  // const onChangeInInput = event => {
  //   const page = event.target.value ? Number(event.target.value) - 1 : 0;
  //   gotoPage(page);
  // };

  const trigger = (v1, v2) => {
    if (v2 === "บันทึกสำเร็จ") {
      toggleRightCanvas();
    }
    refresh(v1);
  };

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);


  return (
    <Fragment>
      {/* <Row className="mb-2">
        <Col
          md={{
            offset: 6,
            size: 2,
          }}
          xl={{
            offset: 10,
            size: 2,
          }}
          className="d-flex justify-content-end p-1 px-3"
        >
          <Button color="primary" onClick={toggleRightCanvas}>
            เพิ่มใบภาษีใหม่
          </Button>
        </Col>
      </Row> */}

      <div className="table-responsive react-table">
        <Table bordered hover {...getTableProps()} className={className}>
          <thead className="table-light table-nowrap">
            {headerGroups.map(headerGroup => (
              <tr key={headerGroup.id} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                  <th
                    key={column.id}
                    className="mb-2"
                    {...column.getSortByToggleProps()}
                  >
                    {column.render("Header")}
                    {generateSortingIndicator(column)}

                    {/* <Filter column={column} /> */}
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody {...getTableBodyProps()}>
            {page.map(row => {
              prepareRow(row);
              const conditionRow = row.original;
              const allNotNull = Object.values(conditionRow).every(
                value => value !== null
              );

              return allNotNull ? (
                <Fragment key={row.getRowProps().key}>
                  <tr>
                    {row.cells.map(cell => {
                      return (
                        <td key={cell.id} {...cell.getCellProps()}>
                          {cell.render("Cell")}
                        </td>
                      );
                    })}
                  </tr>
                </Fragment>
              ) : (
                <tr>
                  <td colSpan="5" className="text-center fs-5">
                    ไม่มีข้อมูล
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>

      <Row className="justify-content-md-end justify-content-center align-items-center mt-3">
        <Col className="mb-2">
          <div className="d-flex gap-1">
            <Button
              className="mx-0"
              style={{ marginTop: "-16px" }}
              color="primary"
              onClick={toggleRightCanvas}
            >
              เพิ่มใบภาษีใหม่
            </Button>
          </div>
        </Col>
        <Col className="d-flex justify-content-center justify-content-sm-end mb-2">
            <Pagination>
              <PaginationItem disabled={!canPreviousPage}>
                <PaginationLink onClick={() => gotoPage(0)}>
                  หน้าแรก
                </PaginationLink>
              </PaginationItem>
              <PaginationItem disabled={!canPreviousPage}>
                <PaginationLink onClick={previousPage}>ย้อนกลับ</PaginationLink>
              </PaginationItem>
              <PaginationItem active>
                <PaginationLink style={{width:windowSize.width < 576 || (windowSize.width >= 576 && windowSize.width < 992 ) ? "70px" : ""}}>
                  หน้า {pageIndex + 1} จาก {pageOptions.length}
                </PaginationLink>
              </PaginationItem>
              <PaginationItem disabled={!canNextPage}>
                <PaginationLink onClick={nextPage}>ถัดไป</PaginationLink>
              </PaginationItem>
              <PaginationItem disabled={!canNextPage}>
                <PaginationLink onClick={() => gotoPage(pageCount - 1)}>
                  หน้าสุดท้าย
                </PaginationLink>
              </PaginationItem>
            </Pagination>
        </Col>
      </Row>

      <Offcanvas
        style={{ border: "none" }}
        autoFocus
        direction="end"
        isOpen={open}
        toggle={toggleRightCanvas}
        fade
        className="fade custom-w-50"
      >
        {/* toggle={toggleRightCanvas} */}
        <OffcanvasHeader style={{ background: "#2a3042", color: "#ffffff" }}>
          <i
            className="fa-regular fa-clipboard pe-1"
            style={{ color: "#ffffff" }}
          ></i>
          บันทึกใบกำกับภาษี
          <div className={"position-absolute top-0 end-0"}>
            <i className={`fa-sharp fa-solid fa-circle-xmark pt-3 pe-3 h4 ${styles.pointer}`} onClick={toggleRightCanvas}></i>
          </div>
        </OffcanvasHeader>
        <OffcanvasBody>
          <AddTex onTrigger={trigger} />
        </OffcanvasBody>
      </Offcanvas>
    </Fragment>
  );
};

TableContainer.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};

export default TableContainer;
